DialogEditFechaCtrl.$inject = ['$log', '$scope', '$http'];
export default function DialogEditFechaCtrl($log, $scope, $http) {
    var DATEFROMAT_SERVIDOR = "YYYY-MM-DD HH:mm:ss";
    var DATEFROMAT_WEB = "DD/MM/YYYY HH:mm:ss";

    var TAG = 'DialogEditFechaCtrl: ';

    var vm = this;
    vm.dialogHandler = $scope.dialog;
    vm.cargando = {
        submit: false
    };
    vm.formDeshabilitado = false;

    vm.fecha = $scope.model.fecha;
    vm.incidenciaId = $scope.model.incidenciaId;

    vm.editFecha = function (incidenciaId, fecha) {
        $log.debug(TAG + 'Editando fecha de la incidencia ' + incidenciaId + ' a ' + fecha);
        var url = Sigo.var.path + '/api/v1/incidencias/' + incidenciaId + '/editar-fecha';
        var data = {fecha: moment(fecha, DATEFROMAT_WEB).format(DATEFROMAT_SERVIDOR)};

        vm.cargando.submit = true;
        vm.formDeshabilitado = true;
        var promesa = $http.post(url, data);
        promesa.then(function (data) {
            $log.debug(TAG + 'Fecha editada correctamente!');
            vm.cargando.submit = false;
            vm.formDeshabilitado = false;
            var texto = Lang.get('seccion_incidencias.mensaje_edit_fecha_ok');
            $.toast({text: texto, icon: 'success', hideAfter: 5000, loader: false});
            vm.dialogHandler.close(data.data);
        }, function (err) {
            $log.error(TAG + 'Error editando la fecha!');
            vm.cargando.submit = false;
            vm.formDeshabilitado = false;
            Sigo.UI.Messages.open([Lang.get('seccion_incidencias.mensaje_edit_fecha_error')], 0);
        });
        return promesa;
    };

    vm.cancelar = function () {
        vm.dialogHandler.cancel();
    }
}